import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/esm/Button';

import Feedback from '../../components/Feedback/Feedback';

import Mate from '../../assets/icons/Mate.png';
import Info from '../../assets/icons/Info.png';
import Tehn from '../../assets/icons/Tehn.png';

import './Meditatii.css';

export default function MeditatiiElevi() {
    return (
        <Container className="meditatiiContainer worldwide">
            <p className="meditatiiTitle">
                <span className="bracket">{'<'}</span>
                Meditații Elevi
                <span className="bracket">{'/>'}</span>
            </p>
            <p className="meditatiiSubTitle">Dacă ai nevoie de ajutor, nu ezita să-l ceri</p>
            <Row className="text-center d-flex align-items-center justify-content-center">
                <Col md={12} lg={6} xl={4} style={{marginTop: "10px"}}>
                    <div className="meditatiiCardsContainer">
                        <div className="text-center d-flex align-items-center justify-content-center">
                            <img src={Mate} className="meditatiiImage" alt="Mate"/>
                        </div>
                        <p className="meditatiiTitle2"><span style={{color: "#4EE39D"}}>Mate</span>matică</p>
                        <hr/>
                        <p className="meditatiiDescription">
                            <span className="bold">Ce vom învăța: </span>Algebră, Analiză, Geometrie și Trigonometrie.
                        </p>
                        <p className="meditatiiDescription">
                            <span className="bold">Pentru ce ne vom pregăti? </span>Școală, Teste, Examene Naționale sau
                            Admitere la facultate.
                        </p>
                        <p className="meditatiiDescription">
                            <span className="bold">Cum și unde se vor desfășura pregătirile? </span>Pregătirile se vor
                            desfășura doar în mediul online pe platforma Google Meet.
                        </p>
                        <p className="meditatiiDescription">
                            <span className="bold">Descriere: </span>Pregătirile la Matematică le susțin în principiu pentru
                            Examenul de Bacalaureat, dar nu numai. Dacă îți dorești să iei o notă mare în examen sau să te
                            descurci mai bine, acesta este momentul să acționezi. Lucrez și pentru Evaluarea Națională.
                        </p>
                        <br/>
                    </div>
                </Col>
                <Col md={12} lg={6} xl={4}>
                    <div className="meditatiiCardsContainer worldwide">
                        <div className="text-center d-flex align-items-center justify-content-center">
                            <img src={Info} className="meditatiiImage" alt="Info"/>
                        </div>
                        <p className="meditatiiTitle2"><span style={{color: "#4EE39D"}}>Info</span>rmatică & <span style={{color: "#4EE39D"}}>TIC</span></p>
                        <hr/>
                        <p className="meditatiiDescription">
                            <span className="bold">Ce vom învăța: </span>Limbajele de programare Python / C / C++ / Microsoft Office / ECDL.
                        </p>
                        <p className="meditatiiDescription">
                            <span className="bold">Pentru ce ne vom pregăti? </span>Școală, Teste, Examene Naționale sau
                            Admitere la facultate.
                        </p>
                        <p className="meditatiiDescription">
                            <span className="bold">Cum și unde se vor desfășura pregătirile? </span>Pregătirile se vor
                            desfășura doar în mediul online pe platforma Google Meet.
                        </p>
                        <p className="meditatiiDescription">
                            <span className="bold">Descriere: </span>Informatica sau TIC-ul, zic eu, reprezintă mai mult decât
                            niște cod scris pe o foaie. Dacă dorești să-ți dezvolți mai mult cunoștințele la
                            Informatică, să iei examenul de Bacalaureat sau pur și simplu să te descurci mai bine
                            la această disciplină, acesta este momentul perfect pentru a începe o colaborare.
                        </p>
                        <br/>
                    </div>
                </Col>
                <Col md={12} lg={6} xl={4}>
                    <div className="meditatiiCardsContainer worldwide">
                        <div className="text-center d-flex align-items-center justify-content-center">
                            <img src={Tehn} className="meditatiiImage" alt="Tehn"/>
                        </div>
                        <p className="meditatiiTitle2"><span style={{color: "#4EE39D"}}>Pro</span>gramare</p>
                        <hr/>
                        <p className="meditatiiDescription">
                            <span className="bold">Ce vom învăța: </span>Pentru atestatul de Informatică sau pură
                            pasiune / curioziate.
                        </p>
                        <p className="meditatiiDescription">
                            <span className="bold">Pentru ce ne vom pregăti? </span>Începători, nivel de școală sau
                            diverse teme / proiecte pentru școală.
                        </p>
                        <p className="meditatiiDescription">
                            <span className="bold">Cum și unde se vor desfășura pregătiriile </span>Pregătirile se vor
                            desfășura doar în mediul online pe platforma Google Meet.
                        </p>
                        <p className="meditatiiDescription">
                            <span className="bold">Descriere: </span>În funcție de nivel și de cerințe, mă pot mula pe
                            ce dorești să lucrăm, de la materii fundamentale de programare, la programare web cu HTML, CSS
                            sau JavaScript.
                        </p>
                        <br/>
                    </div>
                </Col>
            </Row>
            <Row className="text-center">
                <div>
                    <p className="meditatiiSubTitle">{'<'}Pachete & Prețuri{'/>'}</p>
                    <div className="table-responsive worldwide">
                        <Table striped bordered hover className="table-dark text-center centered-table" style={{marginTop: "15px"}}>
                            <thead>
                                <tr>
                                    <th className="centered-cell">Nivel</th>
                                    <th className="centered-cell">Discipline</th>
                                    <th className="centered-cell">Descriere</th>
                                    <th className="centered-cell">Nr. Persoane</th>
                                    <th className="centered-cell">Nr. Ore</th>
                                    <th className="centered-cell">Preț</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td className="centered-cell" rowspan="2">Școală, Atestat, Competențe Digitale, ECDL, Bacalaureat, Admitere</td>
                                    <td className="centered-cell" rowspan="2">Informatică, TIC, Programare</td>
                                    <td className="centered-cell" rowspan="2">Parcurgerea materiei de la 0, rezolvarea exercițiilor specifice, teme la fiecare ședință, feedback constant</td>
                                    <td className="centered-cell" rowspan="2">1</td>
                                    
                                    <td className="centered-cell">1h și 30m</td>
                                    <td className="centered-cell">150 RON</td>
                                </tr>
                                <tr>
                                    <td className="centered-cell" style={{ backgroundColor: "#2C3034" }}>1h</td>
                                    <td className="centered-cell" style={{ backgroundColor: "#2C3034" }}>100 RON</td>
                                </tr>

                                <tr>
                                    <td className="centered-cell" rowspan="2">Școală, Evaluare Națională, Bacalaureat</td>
                                    <td className="centered-cell" rowspan="2">Matematică</td>
                                    <td className="centered-cell" rowspan="2">Parcurgerea materiei de la 0, rezolvarea exercițiilor specifice, teme la fiecare ședință, feedback constant</td>
                                    <td className="centered-cell" rowspan="2">1</td>
                                    
                                    <td className="centered-cell">1h și 30m</td>
                                    <td className="centered-cell">150 RON</td>
                                </tr>
                                <tr>
                                    <td className="centered-cell" style={{ backgroundColor: "#2C3034" }}>1h</td>
                                    <td className="centered-cell" style={{ backgroundColor: "#2C3034" }}>100 RON</td>
                                </tr>

                                <tr>
                                    <td className="centered-cell" rowspan="2">Școală, Atestat, Competențe Digitale, ECDL, Bacalaureat, Admitere</td>
                                    <td className="centered-cell" rowspan="2">Informatică, TIC, Programare</td>
                                    <td className="centered-cell" rowspan="2">Parcurgerea materiei de la 0, rezolvarea exercițiilor specifice, teme la fiecare ședință, feedback constant</td>
                                    <td className="centered-cell" rowspan="2">2-3</td>
                                    
                                    <td className="centered-cell">1h și 30m</td>
                                    <td className="centered-cell">125 RON</td>
                                </tr>
                                <tr>
                                    <td className="centered-cell" style={{ backgroundColor: "#2C3034" }}>1h</td>
                                    <td className="centered-cell" style={{ backgroundColor: "#2C3034" }}>85 RON</td>
                                </tr>

                                <tr>
                                    <td className="centered-cell" rowspan="2">Școală, Evaluare Națională, Bacalaureat</td>
                                    <td className="centered-cell" rowspan="2">Matematică</td>
                                    <td className="centered-cell" rowspan="2">Parcurgerea materiei de la 0, rezolvarea exercițiilor specifice, teme la fiecare ședință, feedback constant</td>
                                    <td className="centered-cell" rowspan="2">2-3</td>
                                    
                                    <td className="centered-cell">1h și 30m</td>
                                    <td className="centered-cell">125 RON</td>
                                </tr>
                                <tr>
                                    <td className="centered-cell" style={{ backgroundColor: "#2C3034" }}>1h</td>
                                    <td className="centered-cell" style={{ backgroundColor: "#2C3034" }}>85 RON</td>
                                </tr>

                                <tr>
                                    <td className="centered-cell">Simulare Test, EN, BAC, Admitere</td>
                                    <td className="centered-cell">Informatică, TIC, Programare, Matematică</td>
                                    <td className="centered-cell">Oferirea unui subiect de bacalaureat cu feedback la final</td>
                                    <td className="centered-cell">1-3</td>
                                    <td className="centered-cell">30m - 2h (după caz)</td>
                                    <td className="centered-cell">50-200 RON</td>
                                </tr>
                            </tbody>
                        </Table>
                    </div>
                </div>
            </Row>
            <Row className="text-center" style={{marginBottom: "-25px"}}>
                <div className="heroButtonContainer">
                    <a href="/contact">
                        <Button className="heroButton">Nu găsești ce cauți? Contactează-mă</Button>
                    </a>
                </div>
            </Row>
            <Row className="text-center" style={{marginTop: "50px", marginBottom: "50px"}}>
                <div>
                    <p className="meditatiiSubTitle">{'<'}Feedback{'/>'}</p>
                    <Feedback/>
                </div>
            </Row>
        </Container>
    )
}